import { Card, CardContent } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";
import { cn } from "utils/cn";

const bone = "bg-border";
const cardClass = "border-[color:var(--dark-secondary-color)]/20 shadow-sm";

const Field = ({ tall }) => (
    <div className="flex min-w-0 flex-col gap-1.5">
        <Skeleton className={cn("h-4 w-24", bone)} />
        <Skeleton className={cn(tall ? "h-24" : "h-10", "w-full rounded-md", bone)} />
    </div>
);

const ProfileSkeleton = () => (
    <div role="status" aria-busy="true" data-testid="profile-skeleton" className="flex min-w-0 flex-col gap-4">
        <span className="sr-only">Loading…</span>
        <div aria-hidden="true" className="flex gap-4">
            <Skeleton className={cn("h-8 w-24", bone)} />
            <Skeleton className={cn("h-8 w-32", bone)} />
            <Skeleton className={cn("h-8 w-28", bone)} />
        </div>
        <div aria-hidden="true" className="grid min-w-0 gap-4 lg:grid-cols-[minmax(0,1fr)_17.5rem]">
            <Card className={cn(cardClass, "order-first h-fit min-w-0 lg:order-none")}>
                <CardContent className="flex items-center justify-center p-4 sm:p-5">
                    <Skeleton className={cn("size-40 rounded-full", bone)} />
                </CardContent>
            </Card>
            <Card className={cn(cardClass, "min-w-0")}>
                <CardContent className="flex min-w-0 flex-col gap-4 p-4 sm:p-5">
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <Field />
                        <Field />
                    </div>
                    <Field />
                    <Field tall />
                    <Field />
                    <div className="flex min-w-0 items-center gap-2">
                        <Skeleton className={cn("h-10 min-w-0 flex-1 rounded-md", bone)} />
                        <Skeleton className={cn("h-10 w-24 shrink-0 rounded-md", bone)} />
                    </div>
                    <div className="flex items-center justify-between gap-3">
                        <Skeleton className={cn("h-4 w-40", bone)} />
                        <Skeleton className={cn("h-6 w-11 rounded-full", bone)} />
                    </div>
                    <Skeleton className={cn("h-4 w-full", bone)} />
                    <Skeleton className={cn("h-4 w-3/5", bone)} />
                </CardContent>
            </Card>
            <Card className={cn(cardClass, "min-w-0 lg:col-start-1")}>
                <CardContent className="flex flex-col gap-2 p-4 sm:flex-row sm:p-5">
                    <Skeleton className={cn("h-10 w-full rounded-md", bone)} />
                    <Skeleton className={cn("h-10 w-full rounded-md", bone)} />
                </CardContent>
            </Card>
        </div>
    </div>
);

export default ProfileSkeleton;
